import { REQUEST_TYPES } from "../constants/api.js";

// -- URI MANIPULATION -- //

export function encodeURIData(data) {
  return Object.keys(data)
    .map(key => [key, data[key]].map(encodeURIComponent).join("="))
    .join("&");
}

// -- FILE MANIPULATION -- //

export function base64ToArrayBuffer(data) {
  var binaryString = window.atob(data);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

// -- DATA SANITISATION -- //

// props to remove from the passed body object
// these should only be standard props required for action flow functionality
// other working props should be removed at source
const _propsToStrip = [
  "endpoint",
  "resources",
  "usage",
  "usageReturnLimit",
  "ignoreChangeInSideEffect"
];

const _propsToProtect = [
  "username",
  "password",
  "passwordConfirmation",
  "oldPassword"
];

export function sanitiseBody(method, data) {
  if (!data) return data;

  // @id is sometimes needed by methods but never by GET requests
  let propsToStrip = _propsToStrip.slice();
  if (method === REQUEST_TYPES.GET) {
    propsToStrip.push("@id");
  }

  let result = Object.assign({}, data);
  for (let i = 0; i < propsToStrip.length; i++) {
    delete result[propsToStrip[i]];
  }

  // shouldn't need to check constructor type if this is a Date object we have bigger issues
  return Object.keys(result).length === 0 ? null : result;
}

export function consoleLogger(method, fullUrl, sanitisedBody) {
  let protectedBody = {
    ...sanitisedBody,
    WARNING: "PROTECTED VALUES REMOVED FROM CONSOLE LOG"
  };

  for (let i = 0; i < _propsToProtect.length; i++) {
    delete protectedBody[_propsToProtect[i]];
  }

  if (!sanitisedBody) {
    console.log("APICALL:", method, fullUrl);
  } else {
    console.log("APICALL:", method, fullUrl, protectedBody);
  }
}
